module.exports = __webpack_public_path__ + "static/Janowo_Park_III_ujecie_01-tablet-7e8e17b1418734add13aa7a380f7ee52.jpg";